import { useEffect, useRef } from 'react';
import css from './Counter.module.scss';

export default function Counter(props) {
    const { val, getHandlers } = props;
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            const val = +ref.current.value || 1;
            // ставимо ширину поля від ширини контента
            const newInputWidth = String(val)?.length * 1.4 + 'ch';
            ref.current.style.width = newInputWidth;
            ref.current.style.minWidth = '1.4ch';
        }
    }, [val]);

    return (
        <div className={css.wrapper}>
            <div className={css.counter}>
                <div {...getHandlers('minus')} className={css.counterBtn}>
                    -
                </div>
                {/* <p className={css.counterValue}>{(val && typeof val === 'number') || +val === 0 ? val : 1}</p> */}
                <input
                    ref={ref}
                    {...getHandlers('change')}
                    className={css.input}
                    type='number'
                    value={String((val && typeof val === 'number') || +val === 0 ? val : 1)}
                />
                <div {...getHandlers('plus')} className={css.counterBtn}>
                    +
                </div>
            </div>
        </div>
    );
}
